import tongxinApi from '@/apis/web/tongxin'

export default {
  inject: ['clinicIdData'],

  data() {
    return {
      // 已授權親友（SAW 2.1 response data.auth）
      authRelations: [],
      // 家庭成員親友（SAW 2.1 response data.family）
      familyRelations: [],
      isCallingFamilyApi: false,
      error: null,
    }
  },

  computed: {
    clinicId() {
      return this.clinicIdData.value
    },

    // 所有親友（合併 auth + family）
    relations() {
      return [...this.authRelations, ...this.familyRelations]
    },
  },

  methods: {
    /**
     * 載入親友列表
     */
    async loadRelations() {
      this.isCallingFamilyApi = true
      this.error = null

      try {
        const response = await tongxinApi.getRelations()
        console.log('loadRelations response:', response)

        // SAW 2.1 response: { auth: [...], family: [...] }
        // tongxinApi 已經做咗 .then(r => r.data)，所以直接用 response
        this.authRelations = response.data?.auth || []
        this.familyRelations = response.data?.family || []
      } catch (error) {
        console.error('載入親友列表失敗:', error)
        this.error = '載入親友列表失敗'
        this.showError('載入親友列表失敗')
      } finally {
        this.isCallingFamilyApi = false
      }
    },

    /**
     * 新增親友
     */
    async handleAddRelation(formData) {
      this.isCallingFamilyApi = true
      this.error = null

      try {
        const payload = {
          ptName: formData.name,
          principalPTIdno: formData.idno,  // 親友身分證
          ptBirthday: formData.birthday,
          patientRelationship: formData.relationship,
          createSource: 'WEB',
        }

        const response = await tongxinApi.createRelation(payload)
        console.log('createRelation response:', response)

        // 導航到成功頁
        this.navigateToSuccess('add')
      } catch (error) {
        const message = error.response?.data?.message || '新增親友失敗'
        console.error('新增親友失敗:', error)
        this.error = message
        this.showError(message)
        throw error
      } finally {
        this.isCallingFamilyApi = false
      }
    },

    /**
     * 更新親友資料
     * Backend 從 Auth::user() 自動帶入 ContactPTIdno（本人身分證）並檢查授權狀態
     */
    async handleUpdateRelation(rowId, formData) {
      this.isCallingFamilyApi = true
      this.error = null

      try {
        const payload = {
          rowid: rowId,
          ptName: formData.name,
          principalPTIdno: formData.idno,  // 親友身分證
          ptBirthday: formData.birthday,
          patientRelationship: formData.relationship,
          createSource: 'WEB',
        }

        const response = await tongxinApi.updateRelation(payload)
        console.log('updateRelation response:', response)

        // 導航到成功頁
        this.navigateToSuccess('edit')
      } catch (error) {
        const message = error.response?.data?.message || '更新親友資料失敗'
        console.error('更新親友資料失敗:', error)
        this.error = message
        this.showError(message)
        throw error
      } finally {
        this.isCallingFamilyApi = false
      }
    },

    /**
     * 刪除親友
     * Backend 從 Auth::user() 自動帶入 ContactPTIdno（本人身分證）並檢查授權狀態
     */
    async handleDeleteRelation(rowId, principalIdno) {
      this.isCallingFamilyApi = true
      this.error = null

      try {
        const payload = {
          rowid: rowId,
          principalPTIdno: principalIdno,  // 親友身分證
        }

        const response = await tongxinApi.deleteRelation(payload)
        console.log('deleteRelation response:', response)

        // 導航到成功頁
        this.navigateToSuccess('delete')
      } catch (error) {
        console.error('刪除親友失敗:', error)
        this.error = '刪除親友失敗'
        this.showError('刪除親友失敗')
        throw error
      } finally {
        this.isCallingFamilyApi = false
      }
    },

    /**
     * 導航到成功頁
     */
    navigateToSuccess(action) {
      const isBookingFlow = this.$route.query.bookingFlow === '1'
      const isBookingMyProfileForm = this.$route.name === 'TongxinFamilyMeAdd'

      if (isBookingFlow && isBookingMyProfileForm) {
        const returnStep = this.$route.query.returnStep || 'confirmation'
        const orgCode = this.$route.params.org_code || this.$route.query.org_code
        const categoryId = this.$route.query.categoryId || undefined

        // 未登入流程（MyProfileForm）直接以表單資料作為掛號對象
        const registrant = {
          rowid: 'self',
          source: 'self',
          name: this.formData?.name || '',
          ssid: this.formData?.idno || '',
        }

        try {
          const raw = localStorage.getItem('tongxin-context')
          const parsed = raw ? JSON.parse(raw) : {}
          const context = parsed.context || {}
          context.registrant = registrant
          parsed.context = context
          localStorage.setItem('tongxin-context', JSON.stringify(parsed))
        } catch (error) {
          console.error('儲存掛號對象失敗:', error)
        }

        this.$router.push({
          name: 'TongxinStep',
          params: {
            org_code: orgCode,
            stepId: returnStep,
            categoryId,
          },
          query: { ...this.$route.query }
        })
        return
      }

      this.$router.push({
        name: 'TongxinFamilySuccess',
        query: { action },
      })
    },

    /**
     * 顯示成功訊息
     */
    showSuccess(message) {
      this.$swal({
        type: 'success',
        title: message,
        confirmButtonText: '確定'
      })
    },

    /**
     * 顯示錯誤訊息
     */
    showError(message) {
      this.$swal({
        type: 'error',
        title: message,
        confirmButtonText: '確定'
      })
    },
  },
}
